import React from 'react'
import { useI18n } from '../i18n/LanguageContext'

function BackToTop() {
  const { t } = useI18n()
  return (
    <a className="to-top" href="#top" aria-label={t.common.backToTop}>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V6m0 0-6 6m6-6 6 6" /></svg>
    </a>
  )
}

export default BackToTop
